<template>
  <div class="row mt-5">
    <div class="col-12 table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col" class="p-0" style="width: 5%">
              <!-- Checkbox Marcar Todos -->
              <input
                v-model="state.checkAll"
                @change="marcarTodos"
                class="form-check-input border"
                type="checkbox"
                title="Marcar/Desmarcar todos"
              />
            </th>
            <th scope="col" class="p-0" style="width: 10%">{{ $t('exercise') }}</th>
            <th scope="col" class="p-0">{{ $t('loads') }}</th>
            <th scope="col" class="p-0 text-center" style="width: 4%">S</th>
            <th scope="col" class="p-0 text-center" style="width: 4%">REP</th>
            <th scope="col" class="p-0 text-center" style="width: 4%">TON</th>
            <th scope="col" class="p-0 text-center" style="width: 4%">PM</th>
            <th scope="col" class="p-0 text-center" style="width: 4%">IMR</th>
          </tr>
        </thead>
        <tbody class="text-sm" v-if="state.treinoElaborado.length === 0">
          <tr>
            <td colspan="8" class="font-weight-bold pt-3 text-decoration-underline text-center">
              {{ $t('noExercisesAdded') }}
            </td>
          </tr>
        </tbody>
        <tbody class="text-sm" v-else>
          <draggable :list="state.treinoElaborado" tag="transition-group" item-key="order" @start="state.drag = true"
            @end="state.drag = false">
            <template #item="{ element, index }">
              <tr>
                <td class="align-middle">
                  <!-- ✅ CHECKBOX ADICIONADO -->
                  <input v-if="element.series.length > 0" v-model="element['checkCopy']"
                    @click="listaExerciciosParaCopiar(index)" class="mb-1 form-check-input border" type="checkbox"
                    value="1" /><br />
                  <span class="pointer" data-bs-toggle="tooltip" :data-bs-original-title="$t('delete')">
                    <i class="fas fa-trash text-secondary" style="font-size: 1.2rem"
                      @click="removerExercicio(index)"></i>
                  </span>
                </td>
                <td class="align-middle" style="width: 20%">
                  <div>
                    <template v-if="element.max_load_test == null || element.max_load_test == 0">
                      {{ element.exercise.name }}
                    </template>
                    <template v-else>
                      <select class="form-control custom-select form-control-sm" name="tested_exercises"
                        v-model="element.exercise_id" @change="mudaExercicioTestado($event.target.value, element)">
                        <option v-for="(item, index) in state.exerciciosTestados" :key="index"
                          :value="item.exercise_id">
                          {{ item.exercise.name }}
                        </option>
                      </select>
                    </template>
                  </div>
                  <div class="mt-2">{{ $t('maxLoad') }}: {{ element.max_load_test }}</div>
                </td>
                <td class="d-flex">
                  <table v-for="(load, loadIndex) in element.series" :key="loadIndex">
                    <tr>
                      <td rowspan="2" style="text-align: center; vertical-align: middle; height: 30px">
                        <input class="form-control form-control-sm carga-input" type="text" v-model="load.load"
                          v-maska="'###'" @change="eventChangeExerciseLoad(index, loadIndex)"
                          style="width: 55px; height: 65px" />
                      </td>
                      <td>
                        <input class="form-control form-control-sm serie-input" type="text" v-model="load.series"
                          v-maska="'###'" @keyup="addCargaExercicio(index, loadIndex)" style="width: 50px" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input class="form-control form-control-sm repeticao-input" type="text"
                          v-model="load.repetitions" v-maska="'###'" @keyup="addCargaExercicio(index, loadIndex)"
                          style="width: 50px" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input class="form-control form-control-sm" type="text" v-maska="'###'"
                          :disabled="!parseInt(element.max_load_test) > 0" v-model="load.perc_load"
                          @keyup="calcularCarga(index, loadIndex, 'perc')" style="width: 46px" />
                      </td>
                      <td class="text-center">
                        <span class="pointer" data-bs-toggle="tooltip" :data-bs-original-title="$t('delete')">
                          <i class="fas fa-trash text-secondary" :title="$t('deleteLoadSeries')"
                            style="font-size: 1.2rem" @click="removerSerie(index, loadIndex)"></i>
                        </span>
                      </td>
                    </tr>
                  </table>
                  <div class="d-grid">
                    <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                      @click="copiaZonas(index)" :title="$t('copyZones')" style="font-size: 0.7rem">
                      {{ $t('copyZones') }}
                    </button>

                    <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                      @click="colarZonas(index)" v-if="CanPasteZones" :title="$t('pasteZones')"
                      style="font-size: 0.7rem">
                      {{ $t('pasteZones') }}
                    </button>
                  </div>
                </td>
                <td class="text-center">{{ calcularEstrategicos('S', index) }}</td>
                <td class="text-center">{{ calcularEstrategicos('REP', index) }}</td>
                <td class="text-center">{{ calcularEstrategicos('TON', index) }}</td>
                <td class="text-center">{{ calcularEstrategicos('PM', index) }}</td>
                <td class="text-center">{{ calcularEstrategicos('IMR', index) }}</td>
              </tr>
            </template>
          </draggable>
        </tbody>
        <!-- ✅ FOOTER COM BOTÕES ADICIONADO -->
        <tfoot>
          <tr>
            <td colspan="8">
              <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                @click="copiarExerciciosSelecionados" style="font-size: 0.7rem;">
                {{ $t('copyExercises') }}
              </button>
              <button type="button" class="ms-3 btn btn-sm font-weight-normal btn-outline-info p-1"
                v-if="pasteExercises" @click="colarExerciciosSelecionados" style="font-size: 0.7rem;">
                {{ $t('pasteSelectedExercises') }}
              </button>
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td></td>
            <td></td>
            <td class="text-end">{{ $t('totals') }}:</td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('S') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('REP') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('TON') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('PM') }}
            </td>
            <td class="text-center">
              {{ totalizadoresEstrategicos('IMR') }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, computed, watch, inject } from 'vue'
import draggable from 'vuedraggable'
import { useStore } from 'vuex'
import planosTreinoRepository from '../../../../services/api/planosTreinoRepository'

export default {
  props: {
    exerciciosProp: {
      type: Array,
      default: [],
    },
    exerciciosTestadosProp: {
      type: Array,
      default: [],
    },
  },
  components: {
    draggable,
  },
  emits: ['update:exerciciosProp'],
  setup(props, { emit }) {
    const store = useStore()
    const swal = inject('$swal')

    // ✅ IMPORTANTE: state DEVE ser definido ANTES dos watch que o referenciam
    const state = reactive({
      treinoElaborado: [],
      exerciciosTestados: [],
      drag: false,
      checkAll: false,
    })

    // ✅ FIX: Watch sincroniza prop com state local
    // Agora usamos two-way binding via emit('update:exerciciosProp')
    let isUpdatingFromProp = false

    watch(
      () => props.exerciciosProp,
      (newVal) => {
        console.log('🔍 [TabelaExercicios] Watch prop disparado!')
        console.log('📥 newVal (prop do pai):', newVal.length, 'exercícios')
        console.log('📤 state.treinoElaborado (local):', state.treinoElaborado.length, 'exercícios')

        // Sincronizar apenas se a mudança veio do pai (adição/substituição)
        // Ignorar se a mudança veio do próprio componente (deleção)
        if (JSON.stringify(newVal) !== JSON.stringify(state.treinoElaborado)) {
          console.log('⚠️ [TabelaExercicios] Arrays são diferentes! Sobrescrevendo...')
          isUpdatingFromProp = true
          state.treinoElaborado = JSON.parse(JSON.stringify(newVal)).map(ex => {
            delete ex.checkCopy
            return ex
          })
          state.checkAll = false
          isUpdatingFromProp = false
        } else {
          console.log('✅ [TabelaExercicios] Arrays são iguais! Ignorando mudança.')
        }
      },
      { deep: true }
    )

    // ✅ FIX: Watch para sincronizar mudanças locais de volta para o pai
    // Isso garante que quando o usuário edita séries/repetições/carga, os dados voltem para o componente pai
    watch(
      () => state.treinoElaborado,
      (newVal) => {
        // Evitar loop infinito: não emitir se a mudança veio da prop
        if (!isUpdatingFromProp && newVal.length > 0) {
          console.log('📤 [TabelaExercicios] Emitindo mudanças locais para o pai')
          emit('update:exerciciosProp', JSON.parse(JSON.stringify(newVal)))
        }
      },
      { deep: true }
    )

    onMounted(() => {
      // ✅ Criar cópia inicial sem checkboxes marcados
      state.treinoElaborado = JSON.parse(JSON.stringify(props.exerciciosProp)).map(ex => {
        delete ex.checkCopy
        return ex
      })
      if (props.exerciciosTestadosProp.length > 0) {
        state.exerciciosTestados = [...props.exerciciosTestadosProp]
      }
    })

    function addCargaExercicio(listaIndex, loadIndex) {
      if (loadIndex >= 0 && listaIndex === 0 && state.treinoElaborado.length > 1) {
        copiarSerieRepeticao(loadIndex)
      }

      let countCargas = state.treinoElaborado[listaIndex]['series'].length
      let ultimoItem = state.treinoElaborado[listaIndex]['series'][countCargas - 1]
      if (ultimoItem.load > 0 || ultimoItem.repetitions > 0 || ultimoItem.series > 0) {
        let obj = {
          repetitions: '',
          load: '',
          perc_load: '',
          series: '',
        }
        state.treinoElaborado[listaIndex]['series'].push(obj)
      }
    }

    function copiarSerieRepeticao(loadIndex) {
      let exercicioTestadoBase = state.treinoElaborado[0]['series'][loadIndex]
      state.treinoElaborado.forEach((obj, index) => {
        if (index > 0) {
          obj['series'][loadIndex]['repetitions'] =
            exercicioTestadoBase['repetitions'] !== '' ? exercicioTestadoBase['repetitions'] : 0
          obj['series'][loadIndex]['series'] =
            exercicioTestadoBase['series'] !== '' ? exercicioTestadoBase['series'] : 0
          addCargaExercicio(index, loadIndex)
        }
      })
    }

    function copiarCargaExercicioTreinado(loadIndex) {
      let exercicioTestadoBase = state.treinoElaborado[0]
      state.treinoElaborado.forEach((obj, index) => {
        if (index > 0) {
          obj['series'][loadIndex]['perc_load'] =
            exercicioTestadoBase['series'][loadIndex]['perc_load']
          calcularCarga(index, loadIndex, 'perc')
        }
      })
    }

    function calcularCarga(listaIndex, loadIndex, tipo = '') {
      if (listaIndex == 0 && state.treinoElaborado.length > 1) {
        copiarCargaExercicioTreinado(loadIndex)
      }

      let item = state.treinoElaborado[listaIndex]
      let itemCarga = item['series'][loadIndex]

      if (tipo == 'perc') {
        // Quando calculando carga a partir da porcentagem:
        // 1. Armazena a porcentagem exata como foi digitada
        // 2. Calcula a carga com base nessa porcentagem exata
        let percentValue = parseFloat(itemCarga.perc_load)
        let result = (item.max_load_test * percentValue) / 100
        state.treinoElaborado[listaIndex]['series'][loadIndex]['load'] = Math.ceil(result)

        // Não recalculamos a porcentagem aqui, mantendo o valor digitado pelo usuário
      } else {
        // Quando calculando porcentagem a partir da carga:
        if (item.max_load_test > 0) {
          // Aqui precisamos garantir que a porcentagem seja o mais próxima possível
          // dos valores redondos que o usuário espera (como 60, 70, 80)
          let loadValue = parseInt(itemCarga.load)
          let exactPerc = (loadValue * 100) / item.max_load_test

          // Arredondamos para o número inteiro mais próximo para evitar valores como 72.09, 81.39
          let roundedPerc = Math.round(exactPerc)

          state.treinoElaborado[listaIndex]['series'][loadIndex]['perc_load'] = roundedPerc.toString()
        } else {
          state.treinoElaborado[listaIndex]['series'][loadIndex]['perc_load'] = '0'
        }
      }
    }

    function removerSerie(listaIndex, loadIndex) {
      if (state.treinoElaborado[listaIndex]['series'].length < 2) return
      state.treinoElaborado[listaIndex]['series'].splice(loadIndex, 1)
    }

    function removerExercicio(listaIndex) {
      swal({
        title: 'Tem certeza?',
        text: `Deseja deletar ${state.treinoElaborado[listaIndex].exercise.name}`,
        showCancelButton: true,
        confirmButtonText: 'Sim, quero deletar!',
        cancelButtonText: 'Não, cancelar!',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn bg-gradient-success',
          cancelButton: 'btn bg-gradient-danger',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          if ('id' in state.treinoElaborado[listaIndex]) {
            deletarExercicioConfirma(state.treinoElaborado[listaIndex]['id'], listaIndex)
          } else {
            console.log('🗑️ [TabelaExercicios] Deletando exercício SEM ID no índice:', listaIndex)
            console.log('📊 Antes:', state.treinoElaborado.length, 'exercícios')
            state.treinoElaborado.splice(listaIndex, 1)
            console.log('📊 Depois:', state.treinoElaborado.length, 'exercícios')
            // ✅ Emitir evento para atualizar o pai
            console.log('📤 Emitindo update:exerciciosProp para o pai')
            emit('update:exerciciosProp', [...state.treinoElaborado])
          }
        }
      })
    }

    function deletarExercicioConfirma(id, listaIndex) {
      store.commit('SET_SPLASH_SCREEN', true)
      planosTreinoRepository
        .PlanoTreinoExercicioGrupoDelete(id)
        .then(function (response) {
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            swal({
              title: 'Removido!',
              text: 'Exercicio removido com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn bg-gradient-success',
              },
              buttonsStyling: false,
            })
            state.treinoElaborado.splice(listaIndex, 1)
            // ✅ Emitir evento para atualizar o pai
            emit('update:exerciciosProp', [...state.treinoElaborado])
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error.message)
          swal({
            icon: 'error',
            title: 'Erro ao deletar exercicio!',
            text: error.message,
          })
        })
    }

    function calcularEstrategicos(tipo, listaIndex) {
      let exercise = state.treinoElaborado[listaIndex]
      let response = 0
      let ton = 0
      let rep = 0
      if (tipo == 'S') {
        exercise.series.forEach((load) => {
          if (load.series != '') {
            response += parseInt(load.series)
          }
        })
      } else if (tipo == 'REP') {
        exercise.series.forEach((load) => {
          if (load.series != '' && load.repetitions != '') {
            response += parseInt(load.series) * parseInt(load.repetitions)
          }
        })
      } else if (tipo == 'TON') {
        exercise.series.forEach((load) => {
          if (load.series != '' && load.load != '' && load.repetitions != '') {
            response += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
          }
        })
      } else if (tipo == 'PM') {
        exercise.series.forEach((load) => {
          if (load.load != '' && load.series != '' && load.repetitions != '') {
            ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
            rep += parseInt(load.series) * parseInt(load.repetitions)
          }
        })
        if (rep > 0) {
          response = parseFloat(ton / rep).toFixed(2)
        }
      } else if (tipo == 'IMR') {
        let ton = 0
        let rep = 0
        exercise.series.forEach((load) => {
          if (load.load != '' && load.series != '' && load.repetitions != '') {
            ton += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
            rep += parseInt(load.series) * parseInt(load.repetitions)
          }
          if (load.series != '') {
            response += parseInt(load.series)
          }
        })
        let pm = parseFloat(ton / rep).toFixed(2)
        if (!exercise.max_load_test) return 0
        return ((pm * 100) / exercise.max_load_test).toFixed(2)
      }
      if (tipo == 'IMR') {
        return parseInt(response)
      }
      return response
    }

    function mudaExercicioTestado(eventValue, element) {
      const exercicioIndex = state.treinoElaborado.findIndex((x) => x.order == element.order)
      const exercicioTestado = state.exerciciosTestados.find((x) => x.exercise_id == eventValue)
      state.treinoElaborado[exercicioIndex].exercise = exercicioTestado.exercise
      state.treinoElaborado[exercicioIndex].exercise_id = exercicioTestado.exercise.id
      state.treinoElaborado[exercicioIndex].max_load_test = exercicioTestado.max_load_test

      if (state.treinoElaborado[exercicioIndex]['series'].length > 0) {
        state.treinoElaborado[exercicioIndex]['series'].forEach((item, index) => {
          const perc = parseFloat(item['perc_load'])
          if (perc > 0) {
            calcularCarga(exercicioIndex, index, 'perc')
          }
        })
      }
    }

    function copiaSeries(index) {
      const series = JSON.parse(JSON.stringify(state.treinoElaborado[index]['series']))

      store.commit('SET_SERIES', series)
    }

    function listaExerciciosParaCopiar(index) {
      state.treinoElaborado[index]['checkCopy'] = !state.treinoElaborado[index]['checkCopy']
    }

    // ✅ FUNÇÃO MARCAR TODOS ADICIONADA
    function marcarTodos() {
      state.treinoElaborado.forEach((item) => {
        if (item.series && item.series.length > 0) {
          item['checkCopy'] = state.checkAll
        }
      })
    }

    // ✅ FUNÇÃO ADICIONADA
    function copiarExerciciosSelecionados() {
      let exercises = []
      state.treinoElaborado.forEach((item) => {
        if (item['checkCopy']) {
          exercises.push(item)
        }
      })
      store.commit('SET_COPY_EXERCISES', exercises)
    }

    // ✅ COMPUTED ADICIONADO
    const pasteExercises = computed(() => {
      return store.getters.getCopyExercises.length > 0
    })

    // ✅ FUNÇÃO ADICIONADA
    function colarExerciciosSelecionados() {
      const items = store.getters.getCopyExercises
      items.forEach((item) => {
        let obj = {
          order: state.treinoElaborado.length + 1,
          exercise: Object.assign({}, item['exercise']),
          max_load_test: item['max_load_test'],
          exercise_id: item['exercise']['id'],
          series: item['series'],
        }
        let duplicate = state.treinoElaborado.some((item) => item.exercise_id == obj.exercise_id)
        if (!duplicate) {
          state.treinoElaborado.push(obj)
        }
      })
    }

    function copiaZonas(index) {
      const series = state.treinoElaborado[index]['series'].map((item) => {
        return {
          load: item.load,
          perc_load: item.perc_load,
          repetitions: item.repetitions,
          series: item.series,
        }
      })
      store.commit('SET_SERIES', series)
    }

    function colarZonas(index) {
      if (parseInt(state.treinoElaborado[index]['max_load_test']) > 0) {
        const maxLoadTest = parseInt(state.treinoElaborado[index]['max_load_test'])
        const series = store.getters.getSeries
        series.forEach((item) => {
          let result = Math.ceil((maxLoadTest * parseFloat(item.perc_load)) / 100)
          const obj = {
            perc_load: item.perc_load,
            repetitions: item.repetitions,
            series: item.series,
            load: result,
          }
          state.treinoElaborado[index]['series'].push(obj)
        })
      } else {
        const series = store.getters.getSeries
        series.forEach((item) => {
          const obj = {
            perc_load: 0,
            repetitions: item.repetitions,
            series: item.series,
            load: item.perc_load,
          }
          state.treinoElaborado[index]['series'].push(obj)
        })
      }
    }

    const CanPasteZones = computed(() => {
      return store.getters.getSeries
    })

    // Modificar função eventChangeExerciseLoad para garantir consistência
    const eventChangeExerciseLoad = (index, loadIndex) => {
      addCargaExercicio(index, -1)

      // Verificar se estamos em um exercício testado (com max_load_test)
      let exercise = state.treinoElaborado[index]
      let load = exercise.series[loadIndex]

      if (exercise.max_load_test > 0) {
        // Se alteramos a carga manualmente, calcula a % correspondente
        calcularCarga(index, loadIndex)

        // Armazenar a porcentagem calculada como string para consistência
        const percValue = parseInt(load.perc_load)
        load.perc_load = percValue.toString()
      }
    }

    function totalizadoresEstrategicos(tipo) {
      let response = 0
      let responseIMR = 0
      let responsePM = 0
      const pesoExercises = state.treinoElaborado

      pesoExercises.forEach((exercise) => {
        if (tipo == 'S') {
          exercise.series.forEach((load) => {
            if (load.series != '' && parseInt(load.series) > 0) {
              response += parseInt(load.series)
            }
          })
        } else if (tipo == 'REP') {
          exercise.series.forEach((load) => {
            if (load.series != '' && load.repetitions != '') {
              response += parseInt(load.series) * parseInt(load.repetitions)
            }
          })
        } else if (tipo == 'TON') {
          exercise.series.forEach((load) => {
            if (load.series != '' && load.load != '' && load.repetitions != '') {
              response += parseInt(load.load) * parseInt(load.series) * parseInt(load.repetitions)
            }
          })
        } else if (tipo == 'PM') {
          responsePM += parseFloat(calcularEstrategicos(tipo, state.treinoElaborado.indexOf(exercise)))
        } else if (tipo == 'IMR') {
          responseIMR += parseFloat(calcularEstrategicos(tipo, state.treinoElaborado.indexOf(exercise)))
        }
      })

      if (tipo == 'IMR') {
        let exerciciosFiltrados = pesoExercises.filter((obj) => {
          let serieLength = obj.series.length
          if (serieLength > 0) {
            let serieLoad = obj.series[serieLength - 1].perc_load
            if (
              parseInt(serieLoad) !== '' &&
              !isNaN(parseInt(serieLoad)) &&
              parseInt(serieLoad) > 0
            ) {
              return obj
            }
          }
          return false
        })
        let responseIMRFinal = responseIMR / (exerciciosFiltrados.length || 1)
        return isNaN(responseIMRFinal) ? 0 : parseInt(responseIMRFinal)
      }
      if (tipo == 'PM') {
        let exerciciosFiltrados = pesoExercises.filter((obj) => {
          let serieLength = obj.series.length
          if (serieLength > 0) {
            let serieLoad = obj.series[serieLength - 1].load
            if (serieLoad !== '') {
              return obj
            }
          }
          return false
        })
        return (responsePM / (exerciciosFiltrados.length || 1)).toFixed(2)
      }
      return response
    }

    return {
      state,
      mudaExercicioTestado,
      addCargaExercicio,
      calcularCarga,
      removerSerie,
      removerExercicio,
      calcularEstrategicos,
      copiaZonas,
      colarZonas,
      CanPasteZones,
      eventChangeExerciseLoad,
      totalizadoresEstrategicos,
      // ✅ EXPORTANDO NOVAS FUNÇÕES
      listaExerciciosParaCopiar,
      copiarExerciciosSelecionados,
      colarExerciciosSelecionados,
      pasteExercises,
      marcarTodos,
    }
  },
}
</script>

<style>
select.custom-select.form-control-sm {
  height: 32.39px;
}

/* Cores mais neutras e agradáveis para as caixas de carga, série e repetição */
.carga-input {
  background-color: #f5f5f5 !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #333 !important;
  text-align: center !important;
  border: 1px solid #e0e0e0 !important;
}

.serie-input {
  background-color: #e3ecfa !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2a4d7a !important;
  text-align: center !important;
  border: 1px solid #b3c6e0 !important;
}

.repeticao-input {
  background-color: #e7f6ef !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
  color: #2e5d47 !important;
  text-align: center !important;
  border: 1px solid #b2dfdb !important;
}
</style>